namespace Areas {
    "use strict";

    const downloadZipButtonName = "downloadZipButton";

    export function addDownloadZip(e: any) {
        const grid: DevExpress.ui.dxDataGrid = e.component;

        grid.on("selectionChanged", toggleDownloadZipButton);

        addButtonToToolbar(e.toolbarOptions, {
            elementAttr: { id: downloadZipButtonName },
            text: "Download Zip",
            type: "normal",
            icon: "arrowdown",
            disabled: true,
            onClick: downloadZip(grid)
        }, "before");        
    } 
    
    export function toggleDownloadZipButton(e: any) {
        if (e.selectedRowKeys.length) {
            Areas.enableButton(downloadZipButtonName);
        } else {
            Areas.disableButton(downloadZipButtonName);
        }
    }

    function downloadZip(dataGrid: DevExpress.ui.dxDataGrid) {
        return (e: any) => {
            const selectedIds = getSelectedIds(dataGrid);
            let url = `/File/Get/AttachmentZip?ids=${selectedIds}`; 
   
            location.href = url;        
        }
    }
    
    function getSelectedIds(dataGrid: DevExpress.ui.dxDataGrid) : string {
        return dataGrid.getSelectedRowsData().map(d => d.attachmentId).join(',');
    }    
}